import { render } from "./InjurySiteEdit.vue?vue&type=template&id=0e0e6c74&scoped=true"
import script from "./InjurySiteEdit.vue?vue&type=script&lang=js"
export * from "./InjurySiteEdit.vue?vue&type=script&lang=js"

import "./InjurySiteEdit.vue?vue&type=style&index=0&id=0e0e6c74&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0e6c74"]])

export default __exports__